import stylex, { keyframes } from '@stylexjs/stylex';

import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';

const skeletonLoading = keyframes({
  '0%': { backgroundPosition: '200% 0' },
  '100%': { backgroundPosition: '-200% 0' },
});
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';

export const styles = stylex.create({
  base: {
    width: '954px',
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },

  header: {
    padding: 0,
    color: colors.primaryText,
  },

  row: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '100%',
    height: '400px',
    overflowX: 'auto',
    padding: '0 0 20px 20px',
  },

  input: {
    padding: '20px 0 20px 0',
  },

  switcherLabel: {
    fontSize: typography['fontSizeCaption-1'],
    paddingLeft: '8px',
    color: colors.primaryText,
  },

  dateLabel: {
    fontSize: typography['fontSizeCaption-1'],
    fonWeight: '400',
    paddingLeft: '16px',
    color: colors.ghostText,
  },
  tabs: {
    width: 'auto',
  },
  qrButtonsPanel: { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '16px' },
  menuItem: {
    color: colors.primaryText,
  },
  segment: {
    padding: '8px 0 ',
  },
  skeletonsBlock: {
    marginTop: '8px',
  },
  segmentSkeleton: {
    height: '44px',
    marginBottom: '16px',
    borderRadius: '8px',
    background: `linear-gradient(90deg, ${colors.tertiaryBackground} 25%, ${colors.ghostBackground} 50%, ${colors.tertiaryBackground} 75%)`,
    backgroundSize: '200% 100%',
    animationName: skeletonLoading,
    animationDuration: '1.5s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
  },
  emptyState: {
    display: 'flex',
    padding: '24px 0 8px',
    color: colors.primaryText,
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: '12px',
  },
  actionsContainer: {
    display: 'flex',
    gap: '16px',
    width: '100%',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    // paddingBottom: '8px',
  },
  label: {
    paddingRight: '10px',
  },
  viewControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: 'auto',
    height: '36px',
  },
  viewButton: {
    display: 'flex',
    padding: '8px 20px 8px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: anatomy['space-8'],
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: colors.hoverBackground,
    },
    borderRadius: anatomy.borderRadiusS,
  },
  filterButton: {
    display: 'flex',
    padding: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: anatomy['space-8'],
    cursor: 'pointer',
    position: 'relative',
    border: `1px solid ${colors.primaryBorder}`,
    backgroundColor: 'transparent',
    borderRadius: anatomy.borderRadiusS,
    ':hover': {
      backgroundColor: colors.brandGhostBackground,
    },
  },
  filterBadge: {
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    width: '14px',
    height: '14px',
    borderRadius: '50%',
    backgroundColor: palette['bronze-500'],
    border: '3px solid #FFF',
  },
  viewLabel: {
    color: colors.primaryText,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },

  filterLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  containerBtn: {
    fontSize: typography['fontSizeCaption-1'],
    fontFamily: fonts.din2014Regular,
    fontStyle: 'normal',
    lineHeight: typography['lineHeightCaption-1'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    marginTop: '8px',
    borderTop: `1px solid ${colors.ghostBorder}`,
  },
});
